/**
 * <s-delivery-estimate> — Rewrites each [data-delivery-days] element with dates
 * calculated from the visitor's current date, formatted as "Nov 3rd".
 *
 * Child markup:
 *   [data-delivery-days="0"]   — single date, today + 0 days.
 *   [data-delivery-days="4,6"] — range "start - end", today + 4 to today + 6 days.
 * The server-rendered text stays as the fallback until this runs.
 */
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function ordinalSuffix(day) {
  const mod100 = day % 100;
  if (mod100 >= 11 && mod100 <= 13) return 'th';
  switch (day % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
}

function formatOffset(today, days) {
  // Building the date from parts lets the Date object roll over month and year ends.
  const date = new Date(today.getFullYear(), today.getMonth(), today.getDate() + days);
  const day = date.getDate();
  return `${MONTHS[date.getMonth()]} ${day}${ordinalSuffix(day)}`;
}

class SDeliveryEstimate extends HTMLElement {
  connectedCallback() {
    const today = new Date();
    for (const el of this.querySelectorAll('[data-delivery-days]')) {
      const offsets = el.dataset.deliveryDays.split(',').map((value) => parseInt(value, 10));
      if (offsets.some(Number.isNaN)) continue;
      el.textContent = offsets.map((days) => formatOffset(today, days)).join(' - ');
    }
  }
}

if (!customElements.get('s-delivery-estimate')) {
  customElements.define('s-delivery-estimate', SDeliveryEstimate);
}
